// src/router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '/src/store'

// 假设已有Home页面
import LogIn from '@/view/logIn.vue'
import myShop from '@/view/myShop/myShop.vue'
import goodsList from '@/view/goodsList/goodsList.vue'
//新增的
import newGoods from '@/view/goodsList/newGoods.vue'

import MainLayout from '@/components/MainLayout.vue'

import takeOutOrder from '@/view/order/takeOutOrder.vue'
import shopOrder from '@/view/order/shopOrder.vue'
import guestRemark from '@/view/order/guestRemark.vue'

import shopDate from "@/view/manage/shopDate.vue"
import goodsDate from "@/view/manage/goodsDate.vue"
import activityPrizeList from "@/view/activities/activityPrizeList.vue"


// 必须显式调用 Vue.use()
Vue.use(VueRouter)

const routes = [{
		path: '/login',
		name: 'LogIn',
		component: LogIn
	},
	{
		path: '/',
		component: MainLayout,
		redirect: '/myShop',
		children: [
			// ========== 我的店铺 ==========
			{
				path: 'myShop',
				component: myShop,
				meta: {
					group: '我的店铺',
					title: '店铺管理',
					requiresAuth: true
				}
			},

			// ========== 商品管理 ==========
			{
				path: 'goodsList',
				component: goodsList,
				meta: {
					group: '商品管理',
					title: '商品列表',
					requiresAuth: true
				},
				children: [{
						path: 'newGoods', // 访问路径为 /goodsList/new
						component: newGoods,
						meta: {
							title: '新增商品',
							requiresAuth: true
						}
					}
					// 更多子页面可继续添加
				]
			},

			// ========== 订单管理 ==========
			{
				path: 'takeOutOrder',
				component: takeOutOrder,
				meta: {
					group: '订单管理',
					title: '外卖订单',
					requiresAuth: true
				}
			},
			{
				path: 'shopOrder',
				component: shopOrder,
				meta: {
					group: '订单管理',
					title: '到店订单',
					requiresAuth: true
				}
			},
			{
				path: 'guestRemark',
				component: guestRemark,
				meta: {
					group: '订单管理',
					title: '顾客评价',
					requiresAuth: true
				}
			},
			{
				path: 'shopDate',
				component: shopDate,
				meta: {
					group: '经营管理',
					title: '店铺数据',
					requiresAuth: true
				}
			},
			{
				path: 'goodsDate',
				component: goodsDate,
				meta: {
					group: '活动管理',
					title: '商品数据',
					requiresAuth: true
				}
			},
			{
				path: 'activityPrizeList',
				component: activityPrizeList,
				meta: {
					group: '活动办理',
					title: '奖券列表',
					requiresAuth: true
				}
			},
		]
	}

	// 添加更多路由...
]

const router = new VueRouter({
	mode: 'hash', // 或 'history'（需服务器支持）
	routes
})



router.beforeEach(async (to, from, next) => {
	if (!to.matched.some(record => record.meta.requiresAuth)) {
		next();
		return;
	}

	if (!store.getters['auth/isAuthenticated']) {
		next({
			path: '/login',
			query: {
				redirect: to.fullPath
			}
		});
		return;
	}

	try {
		await store.dispatch('auth/ensureStoreId');
		next();
	} catch (error) {
		store.dispatch('auth/logout');
		next({
			path: '/login',
			query: {
				redirect: to.fullPath
			}
		});
	}
});

export default router
